import { MouseEvent } from 'react'
import { Button, FlexBox, RatingsStars } from '@vp/swan'

import { reviewsId } from 'client/components/Gallery/Header/RatingsSummary/constants'
import { scrollToElement } from 'client/utils/scrollToElement'
import { useTranslations } from '~/client/hooks/useTranslations'
import { RatingsSummaryProps } from 'client/components/Gallery/Header/RatingsSummary/interface'

export const RatingsSummary = ({ averageRating, reviewsCount }: RatingsSummaryProps) => {
  const localize = useTranslations()

  const handleScrollToReviews = (event: MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault()

    scrollToElement(reviewsId, { behavior: 'smooth' })
  }

  return (
    <FlexBox alignItems="center" fontSize="small">
      <Button aria-label={localize('ShowReviews')} className="rating-link" skin="unstyled" onClick={handleScrollToReviews}>
        <RatingsStars ratingValue={averageRating} reviews={reviewsCount} />
      </Button>
    </FlexBox>
  )
}

RatingsSummary.displayName = 'RatingsSummary'
